import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { tokens } from "../../../../../../theme";

interface VenueWidgetProps {
  title: string;

  children: React.ReactNode;
  sx?: object;
}

const VenueWidgets: React.FC<VenueWidgetProps> = ({ title, children }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: colors.primary[900],
        height: "100%",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h6"
        textAlign="center"
        sx={{ fontWeight: "bold", mb: 1 }}
      >
        {title}
      </Typography>

      <Box sx={{ flex: 1 }}>{children}</Box>
    </Box>
  );
};

export default VenueWidgets;
